import { CanvasRenderingCtx } from '../rendering';
import { PhotoEditorAnnotationCanvasRenderer } from './photo-editor.decorator';
import { TextAnnotation } from './annotation';

export class TextPenRenderer implements PhotoEditorAnnotationCanvasRenderer<TextAnnotation> {
  constructor(
    private readonly ctx: CanvasRenderingContext2D,
    public annotation: TextAnnotation,
  ) {}

  draw(renderingCtx: CanvasRenderingCtx): void {
    this.ctx.save();

    if (this.annotation.text) {
      this.ctx.fillStyle = this.annotation.color;
      this.ctx.textAlign = 'start';
      this.ctx.textBaseline = 'middle';
      this.ctx.font = `bold ${this.annotation.fontSize}px Open Sans`;

      this.ctx.translate(this.annotation.origin.x, this.annotation.origin.y);
      if (this.annotation.angle) {
        this.ctx.rotate(this.annotation.angle);
      }

      this.ctx.scale(1, -1);
      this.ctx.fillText(this.annotation.text, 0, 0);
    }

    this.ctx.restore();
  }
}
